<template>
  <div class="merchant-detail-container">
    <swiper v-if="!$isMobile && detail" class="merchant-swiper" ref="-swiper" :options="options">
      <template v-if="detail.banner_urls.length > 0 && detail.banner_urls[0] != null">
        <swiper-slide class="swiper__item" v-for="(item, index) in detail.banner_urls" :key="index">
          <img :src="item | parseImage" alt width="100%" />
        </swiper-slide>
      </template>
      <template v-else>
        <swiper-slide class="swiper__item">
          <img src="http://api.material-online.cn/public/uploads/images/20220215/ac9e72553364282925c78bf08ea3d5be.jpg" alt width="100%" />
        </swiper-slide>
      </template>
    </swiper>

    <div class="--detail-merchant" :class="{'web-height':!$isMobile}">
      <div>
        <template v-if="!$isMobile">
          <div class="designer-details">
            <span>
              <p>关注</p>
              <h5>{{infos.followNum}}</h5>
            </span>
            <span>
              <p>留言</p>
              <h5>{{infos.chatNum}}</h5>
            </span>
            <span v-if="detail">
              <img :src="detail.avatar" alt class="img" />
              <div class="text__name">{{ detail.company }}</div>
              <b class="focus" v-if="detail.is_follow==0" @click="userCommunication">关注</b>
              <b class="focus" @click="unUserCommunication" v-else>已关注</b>
            </span>
            <span>
              <p>评论</p>
              <h5>{{infos.commentNum}}</h5>
            </span>
            <span>
              <p>动态</p>
              <h5>{{counts.dynamics}}</h5>
            </span>
          </div>
          <div class="com-details ellipsis2">{{detail && detail.store_content}}</div>
        </template>
        <template v-else>
          <div class="mobile-detail-parameters-container">
            <div class="detail-designer-info detail__child">
              <div class="store-logo">
                <div class="__logo" v-if="detail">
                  <img :src="detail.avatar" alt />
                </div>
              </div>
              <div class="store-info">
                <div class="info__item">{{ detail && detail.company }}</div>
                <div
                  class="focus"
                  v-if="detail && detail.is_follow==0"
                  @click="userCommunication"
                >关注</div>
                <div class="focus" @click="unUserCommunication" v-else>已关注</div>
              </div>
              <div>{{detail && detail.store_content}}</div>
            </div>
            <div class="designer-child">
              <div class="info__list">
                <span>
                  <p>关注</p>
                  <h5>{{infos.followNum}}</h5>
                </span>
                <span>
                  <p>留言</p>
                  <h5>{{infos.chatNum}}</h5>
                </span>
                <span>
                  <p>评论</p>
                  <h5>{{infos.commentNum}}</h5>
                </span>
                <span>
                  <p>动态</p>
                  <h5>{{counts.dynamics}}</h5>
                </span>
              </div>
              <div class="info__other" v-if="detail">
                <p>
                  <span>电话：</span>
                  {{ detail.phone }}
                </p>
                <!-- <p><span>邮箱：</span>{{ detail.email }}</p> -->
                <p>
                  <span>网址：</span>
                  {{ detail.store_url }}
                </p>
                <p>
                  <span>公司：</span>
                  {{ detail.company }}
                </p>
                <p>
                  <span>地址：</span>
                  {{ detail.address }}
                </p>
                <!-- <p :class="{'show-one':isShowOne == true}"><span>简介：</span>这个是简介这个是简介这个是简介这个是简介这个是简介这个是简介这个是简介这个是简介</p>
               <h5 @click="changeIsShowOne" v-if='isShowOne == true'>展开</h5>
                <h5 @click="changeIsShowOne" v-if='isShowOne == false'>收起</h5>-->
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <!--<div class="detail-container__base-info-container --detail-merchant" v-if="detail">
      <div class="base-info__wrapper">
        <div class="base-info__info">
          <div class="info__wrapper">
            <div class="info__mix">
              <div class="info__logo">
                <img :src="detail.avatar" alt="" />
              </div>
            </div>
            <div class="info__text member-center">
              <div class="text__name">
                <strong>{{ detail.company }}</strong>
              </div>
              <div class="text__type">
                <p class="type__text">{{ detail.identity_name }}</p>
                <p v-if="detail.company" style="" class="type__text">{{ detail.company }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    -->
    <div class="detail-container__main-body">
      <div class="main-body__nav-container">
        <div class="nav-container__wrapper">
          <router-link
            :to="nav.url"
            class="nav-item"
            v-for="(nav, index) in merchantNav"
            :key="index"
            active-class="merchant-link-active"
          >
            {{ nav.name }}
            <b v-if="(index + 1) != merchantNav.length">（{{ counts[nav.sign] }}）</b>
          </router-link>
        </div>
      </div>
      <div class="main-body__main-info-container">
        <router-view v-if="detail" :detail="detail"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { mapState } from "vuex";
import designerBj from "@/assets/images/designer_bj.jpg";

export default {
  props: ["userid"],
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      detail: undefined,
      designerBj,
      infos: {},
      counts: {
        cases: 0,
        dynamics: 0,
        demands: 0,
        articles: 0
      },
      pageSize: 15,
      id: 0,
      isShowOne: false,
      userCommunic: {},
      options: {
        autoplay: {
          delay: 2500,
          stopOnLastSlide: false,
          disableOnInteraction: false
        }
      }
    };
  },
  computed: {
    ...mapState("user", {
      userInfo: state => state.info
    }),
    merchantNav() {
      if (this.$isMobile === true) {
        return [
          {
            name: "案例",
            url: `/member/${this.userid}/cases`,
            sign: "cases"
          },
          {
            name: "文章",
            // url: `/member/${this.userid}/dynamics`,
            // sign: 'dynamics',
            url: `/member/${this.userid}/articles`,
            sign: "articles"
          },
          {
            name: "需求",
            url: `/member/${this.userid}/demand`,
            sign: "demands"
          },
          {
            name: "联系我",
            url: `/member/${this.userid}/contact`,
            sign: "contact"
          }
        ];
      }
      return [
        {
          name: "案例",
          url: `/member/${this.userid}/cases`,
          sign: "cases"
        },
        {
          name: "文章",
          // url: `/member/${this.userid}/dynamics`,
          // sign: 'dynamics',
          url: `/member/${this.userid}/articles`,
          sign: "articles"
        },
        {
          name: "需求",
          url: `/member/${this.userid}/demands`,
          sign: "demands"
        },
        {
          name: "联系我",
          url: `/member/${this.userid}/contact`,
          sign: "contact"
        }
      ];
    },
    page() {
      return this.$route.query.page || 1;
    }
  },
  watch: {
    $route: {
      handler: "init",
      immediate: true
    }
  },
  methods: {
    async init() {
      if (!this.userInfo) {
        this.$router.push({
          path: "/login"
        });
        return;
      }
      this.$store.commit("openLoading");
      const detail = await this.$http.post("html/Publiccon/businessCard", {
        id: this.userid,
        store_id: ""
      });
      this.detail = detail.data;
      this.infos = detail.data;
      console.log(this.$route.query.contact);
      const data = {
        id: this.userid,
        store_id: "",
        page: this.page,
        page_size: this.pageSize
      };
      const requests = [
        this.$http.post("html/Publiccon/businessCase", data),
        this.$http.post("html/Publiccon/businessDynamic", data),
        this.$http.post("html/Publiccon/businessDemand", data),
        this.$http.post("html/user/myKnowledge", data)
      ];
      const res = await this.$http.multi(requests);
      // console.log(res);
      const [caseRes, dynamicRes, demandRes, storeArticle] = res;
      this.counts.cases = caseRes.data.list.length;
      this.counts.dynamics = dynamicRes.data.list.length;
      this.counts.demands = demandRes.data.list.length;
      this.counts.articles = storeArticle.data.list.length;
      this.$store.commit("closeLoading");
    },
    changeIsShowOne() {
      this.isShowOne = this.isShowOne == false;
    },
    async userCommunication() {
      const userCommunic = await this.$http.post(
        "html/Publiccon/userCommunication",
        {
          id: this.userid
        }
      );
      console.log(userCommunic.success);
      if (userCommunic.success === true) {
        this.detail.followNum = +1;
        this.detail.is_follow = 1;
        this.$message({
          type: "success",
          message: "关注成功"
        });
      }
    },
    async unUserCommunication() {
      const userCommunic = await this.$http.post(
        "html/Publiccon/unUserCommunication",
        {
          id: this.userid
        }
      );
      console.log(userCommunic.success);
      if (userCommunic.success === true) {
        this.detail.followNum = this.detail.followNum - 1;
        this.detail.is_follow = 0;
        this.$message({
          type: "success",
          message: "取消关注成功"
        });
      }
    }
  }
};
</script>

<style lang="scss">
.merchant-detail-container {
  .com-details {
    width: 766px;
    margin: 0 auto;
    padding: 30px 20px 0;
    line-height: 24px;
  }
  .merchant-swiper {
    .swiper-slide {
      width: 100vw !important;
      max-height: 496px;
    }
  }
  .--detail-merchant {
    position: relative;
    z-index: 1;
  }
}
</style>
